export const ORDER_HOOK_TYPE_SWITCH_PRICE = 'switch_price';
export const ORDER_HOOK_TYPE_SWITCH_PRODUCT = 'swtich_product';
export const ORDER_HOOK_TYPE_MAKE_CANCELLABLE = 'make_cancellable';
export const ORDER_HOOK_TYPE_REDUCE_QUANTITY = 'reduce_quantity';



// WEBPACK FOOTER //
// ./src/constants/OrderHookTypes.js